import React, { PureComponent } from "react";
import "../WordCloud/WordCloudSelector.scss";
import CustomDropdown from "../ChartsOptionsSidebar/CustomDropdown";

class WordCloudSelector extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            aggs: props.appliedFilter && props.appliedFilter.aggs ? props.appliedFilter.aggs : "ocr-frequency-wordcloud",
        };
    }

    render() {
        const aggsIntervalOptions = [
            { key: "frequency", label: "Frequency", value: "ocr-frequency-wordcloud" },
            // { key: "impact", label: "Impact", value: "ocr-impact-wordcloud" },
        ];

        let obj = this.props.appliedFilter.aggs;

        return (
            <CustomDropdown
                className="interval-selector"
                name="Type of Wordcloud"
                onChange={this.props.handleAggsChange}
                value={obj}
                options={aggsIntervalOptions}
            />
        );
    }
}

export default WordCloudSelector;
